import type { HTMLAttributes, ReactNode, TableHTMLAttributes } from 'react';
import styles from './Table.module.css';

export function Table({ children, className, ...rest }: TableHTMLAttributes<HTMLTableElement>) {
  return (
    <div className={styles.wrap}>
      <table className={[styles.table, className].filter(Boolean).join(' ')} {...rest}>
        {children}
      </table>
    </div>
  );
}

export function Mono({ children }: { children: ReactNode }) {
  return <span className={styles.mono}>{children}</span>;
}

export function RowActions({ children, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={styles.actions} {...rest}>
      {children}
    </div>
  );
}
